import { action, observable, when } from 'mobx';
import { useStaticRendering } from 'mobx-react';
import { isBrowser } from '@config/env';

// eslint-disable-next-line react-hooks/rules-of-hooks
useStaticRendering(!isBrowser);

export const ztInitInfo = {
    params: {
        from: 0,
        fromtype: 0
    }, //url参数
    ztConfig: {
        serverTime: 0,
        name: ''
    }, //专题配置项
    navObj: {},
    /**
     * 来源渠道
     */
    get client_source() {
        return this.params.from || this.params.fromtype || 6312;
    },
    /**
     * 承接渠道
     */
    get client_type() {
        return 6312;
    },
    shareInfo: {}
};

class BaseInfoStore {
    @observable
    userInfo = {
        uid: 0,
        ccid: 0,
        urs: '',
        nickname: ''
    }; //用户信息

    @observable
    anchorInfo = {
        anchorId: 0
    }; //主播信息

    liveInfo = {}; //直播信息

    @observable
    isLogin = undefined; // 是否已登录，初始状态为undefined，等到自动登录完成后，再赋值true/false

    @action
    setUserInfo = (info) => {
        //设置用户信息
        this.userInfo = info;
        if (info && info.uid) {
            this.isLogin = true;
        } else {
            this.isLogin = false;
        }
    };

    @observable
    showReview = false; //显示往期回顾

    @observable
    showMask = false; //显示遮罩层

    @observable
    bookInfo = {
        //预约信息
        bookStatus: '', //预约状态，根据此值来显示不同弹窗，为空时隐藏弹窗
        bookTipText: '', //预约结果弹窗文案
        bookConfirmText: '', //确认预约弹窗文案
        bookLogInfo: {}, //预约点击日志信息
        succFun() {} //预约成功回调函数
    };

    @action
    setBookInfo = (info) => {
        //设置预约信息
        this.bookInfo = {
            bookStatus: info.status || '',
            bookTipText: info.text || '',
            bookConfirmText: info.confirmText || '',
            bookLogInfo: info.bookLogInfo || this.bookInfo.bookLogInfo,
            succFun: info.succFun || (() => {})
        };
    };

    @observable
    showCloud = false; //是否显示浮层

    @observable
    cloudText = ''; //浮层文案

    @action
    setShowCloud = (text) => {
        //设置浮层信息
        this.showCloud = true;
        this.cloudText = text || '';
        setTimeout(() => {
            this.showCloud = false;
        }, 2000);
    };

    @observable
    showCancelFollowWin = false; //是否显示取消关注弹窗

    jwtToken = ''; //身份验证jwt

    @action
    setData = (key, value) => {
        //设置baseinfo字段值
        this[key] = value;
    };

    @observable
    iframeFullScreen = false; //直播间iframe全屏

    @observable
    isInRoom = false; //是否在直播间内

    @observable
    showHistory = false; //显示中奖记录弹窗

    historyPageUrl = ''; //中奖记录弹窗页面地址

    pageItemScrollTop = {}; // 各模块位置信息
    pageItemDom = {}; // 各模块dom信息

    @observable
    tipWinArr = []; // 提示框信息数组,支持同时弹多个

    @action
    setTipWinArr = (item, action) => {
        //设置提示框
        if (action > 0) {
            this.tipWinArr.push(item);
        } else {
            this.tipWinArr.shift();
        }
    };

    @observable
    followArr = {}; //关注人列表信息

    @action
    setFollowArr = (uid, value) => {
        let obj = {};
        obj[uid] = value;
        this.followArr = Object.assign({}, this.followArr, obj);
    };

    @action
    setAnchorInfo = (key, value) => {
        this.anchorInfo[key] = value;
    };

    @action
    getAnchorInfo = () => {
        return this.anchorInfo;
    };

    @observable
    initedDomain = false; // 开发、测试环境配置domain

    @action
    setInitedDomain = (status) => {
        this.initedDomain = status;
    };

    @observable
    executedCCSDK = false; // 是否已执行完ccsdk，即ClientICC!=undefined

    @observable
    webLinkLogined = undefined; // weblink是否执行了2-2

    /**
     * 当用户已完成自动登录，不一定成功
     */
    whenAutoLoginCompleted = async () => {
        return await when(() => this.isLogin !== undefined);
    };

    /**
     * 当用户已完成自动登录，不一定成功
     */
    whenExecutedCCSDK = async () => {
        return await when(() => this.executedCCSDK == true);
    };
}

const baseInfo = new BaseInfoStore();
export default baseInfo;
